import React from 'react';

export default function IconOrderbook() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3332 1.3335H3.6665C3.11422 1.3335 2.6665 1.78121 2.6665 2.3335V13.6668C2.6665 14.2191 3.11422 14.6668 3.6665 14.6668H12.3332C12.8855 14.6668 13.3332 14.2191 13.3332 13.6668V2.3335C13.3332 1.78121 12.8855 1.3335 12.3332 1.3335Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.6665 4L13.3332 4"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3335 8H5.9935"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99951 8H10.6662"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3335 10.666H5.9935"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99951 10.666H10.6662"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
